import $ from 'jquery';
import _ from 'underscore';
import i18n, { t }  from '../i18n/i18n.js';
import LoadingPopupView from '../../controls/LoadingPopupView.js';
import ContactViewArea from '../../shared_views/ContactViewArea.js';
import ContactEditArea from '../../shared_views/ContactEditArea.js';
import PopupBase from './PopupBase.js';
import app from '../App.js';
import Vue from 'vue';
import ContactCallSessionTab from './ContactCallSessionTab.vue';

var ContactInfoPopup = PopupBase.extend({

    className: 'popup-frame large-size contact-popup',
    hasAutoReposition: false,
    hasContentArea: false,

    initialize: function (options) {

        options = options || {};

        var entityId = (options.leadMode ? options.leadId : options.contactId);
        var entityName = (options.leadMode ? options.leadName : options.contactName);

        if (!options.title) {
            options.titleHtml = true;
            options.title =
                (entityId || entityName) ?
                    t('contact_popup.title_format', { 'name': entityName || '' }) :
                    t('contact_popup.title_new');
        }

        ContactInfoPopup.__super__.initialize.call(this, options);

        var that = this;

        this.tabNames = ['profile', 'call_history', 'orders'];
        if (options.tabs) {
            this.tabNames = _.intersection(this.tabNames, [].concat(options.tabs));
        }
        if (!this.tabNames.includes(options.selected)) {
            options.selected = null;
        }

        $('<div class="main-tabbed-area">').appendTo(that.$el).append(
            that.$tabs = $('<div class="main-tabbed-area-tabs">'),
            that.$sections = $('<div class="main-tabbed-area-section">')
        );

        that._tabs = {};

        for (const tabName of this.tabNames) {
            switch (tabName) {
                case 'lead':
                    that.addTab('lead', t('contact_popup.tab_lead'), false, () => that.getProfileTabContent());
                    break;
                case 'profile':
                    that.addTab('profile', t('contact_popup.tab_profile'), false, () => that.getProfileTabContent());
                    break;
                case 'call_history':
                    that.addTab('call_history', t('contact_popup.tab_call_history'), false, entityId ? () => that.getCallHistoryTabContent() : false);
                    break;
                case 'orders':
                    that.addTab('orders', t('contact_popup.tab_orders'), false, entityId ? () => that.getOrdersTabContent() : false);
                    break;
            }
        }

        that.activateTab(options.selected || this.tabNames[0]);
    },

    addTab: function (name, title, href, contentCallback) {
        var that = this;

        // If an href is attached to a tab, then the Router will change the URL in address,
        // but prevent re-loading the page by detecting current loaded page,
        // And then activateTab will be called live for the actual click and not the url change

        var $tabButton;

        that._tabs[name] = {
            $tab: $tabButton =
                (href ? $('<a class="tab">').attr('href', href) : $('<span class="tab">').fakebutton())
                    .toggleClass('disabled', !href && !contentCallback)
                    .prop('disabled', !href && !contentCallback)
                    .text(title)
                    .appendTo(that.$tabs),
            $wrapper: $('<div class="main-area-tab-section">').hide().appendTo(that.$sections),
            contentCallback: contentCallback
        };

        if (href || contentCallback) {
            $tabButton.click(function(){ that.activateTab(name); })
        }

        return that;
    },

    activateTab: function (name) {
        var that = this;

        var tab = that._tabs[name];

        if (tab.contentCallback) {
            var $content = tab.contentCallback();
            if ($content) {
                $content.appendTo($('<div class="initiated-calls-area">').appendTo(tab.$wrapper));
            }
            tab.contentCallback = null;
        }

        that.$tabs.find('>.tab').removeClass('selected');
        that.$sections.find('>.main-area-tab-section').hide();

        tab.$tab.addClass('selected');
        tab.$wrapper.show();

        return that;
    },

    getProfileTabContent: function () {
        var that = this, options = that.options;

        var $el = that.$contactSection = $('<div>');

        $(i18n.processLocalizedString('<div class="section-subtitle-wrapper"><h3>{contact_popup.contact.title}</h3></div>')).appendTo($el);

        var entityId = (options.leadMode ? options.leadId : options.contactId);

        if (entityId) {

            var loader = that._contactLoader = new LoadingPopupView(t('activity_indicator.loading'));

            setTimeout(function () { // Do after rendering to screen
                loader.show($el);

                var url;
                if (options.leadMode) {
                    url = 'leads/' + encodeURIComponent(entityId);
                }
                else {
                    url = 'contacts/' + encodeURIComponent(entityId);
                }

                (that._loadContactXhr = $.get(app.apiUrl(url)))
                    .always(function () {
                        loader.hide();
                    })
                    .then(function (contact) {
                        that._contactData = contact;

                        if (options.leadMode) {
                            try {
                                contact['custom_fields'] = JSON.parse(contact['custom_fields']);
                            } catch (e) {
                                contact['custom_fields'] = {};
                            }
                        }

                        that.renderProfileView();
                    })
                    .fail(function (xhr, error) {
                        app.showXhrError(xhr, error);
                    });

            }, 0);

        } else {

            that.renderProfileEdit();

        }

        return $el;
    },

    renderProfileView: function () {
        var that = this;

        var $container = that.$contactSection.empty();

        $('<div class="section-subtitle-wrapper">').append(
            $('<h3>').text(t('contact_popup.contact.title')),
            $('<button class="edit-button">').text(t('edit')).click(that.renderProfileEdit.bind(that))
        ).appendTo($container);

        var view = new ContactViewArea({
            i18n: i18n,
            contact: that._contactData
        });
        view.$el.appendTo($container);
        view.render();

        $('<div class="popup-actions">').append(
            $('<button class="edit-button">').text(t('edit')).click(that.renderProfileEdit.bind(that))
        ).appendTo($container);

        return that;
    },

    renderProfileEdit: function () {
        var that = this;

        var $container = that.$contactSection.empty();

        $('<div class="section-subtitle-wrapper">').append(
            $('<h3>').text(t('contact_popup.contact.title')),
            $('<button class="edit-button">').text(t('save')).click(that.onSave.bind(that))
        ).appendTo($container);

        var editAreaOptions = {
            i18n: i18n,
            contact: that._contactData || that.options.preData
        };

        $.extend(editAreaOptions, that.options.newContactOptions);

        var view = that._editArea = new ContactEditArea(editAreaOptions);
        view.$el.appendTo($container);
        view.render();

        $('<div class="popup-actions">').append(
            $('<button class="edit-button">').text(t('save')).click(that.onSave.bind(that))
        ).appendTo($container);

        return that;
    },

    onSave: function () {
        var that = this, options = that.options;
        if (that._isSaving) return that;

        var savedContact = that._editArea.getContactData();

        var postData = savedContact;
        if (options.leadMode) {
            postData = _.extend({}, postData);
            postData['custom_fields'] = JSON.stringify(postData['custom_fields']);
        }

        var entityId = (options.leadMode ? options.leadId : options.contactId);

        var saveUrl = that.options.leadMode ? 'leads/' : 'contacts/';
        if (entityId) {
            saveUrl += encodeURIComponent(entityId);
        }

        that._isSaving = true;
        var loader = that._contactLoader = new LoadingPopupView(t('activity_indicator.saving'));
        (that._saveContactXhr = $.ajaxJsonPost(app.apiUrl(saveUrl), postData))
            .always(function () {
                loader.hide();
                that._isSaving = false;
            })
            .then(function(response) {
                if (options.leadMode) {
                    options.leadId = response['id'];
                } else {
                    options.contactId = response['id'];
                }
                that._contactData = that._contactData || {};
                savedContact['custom_fields'] = _.extend({}, that._contactData['custom_fields'], savedContact['custom_fields']);
                _.extend(that._contactData, savedContact); // Copy over the new values

                that.renderProfileView();

                that.trigger('contactsave', that._contactData);
            })
            .fail(function(xhr, error) {
                app.showXhrError(xhr, error);
            });
    },

    getCallHistoryTabContent: function () {
        const that = this;

        this.vueApp = new Vue({
            render: function (h) {
                return h(ContactCallSessionTab, {
                    props: {contactId: that.options.contactId}
                })
            }
        }).$mount();

        return $(this.vueApp.$el);
    },

    getOrdersTabContent: function () {
        var that = this;

        var $el = $('<div>');

        $(i18n.processLocalizedString('<div class="section-subtitle-wrapper"><h3>{contact_popup.last_orders.title}</h3></div>')).appendTo($el);

        var $table = $('<table class="simple-report">').appendTo($el);

        $table.html(i18n.processLocalizedString('<thead><tr>' +
        '<th>{contact_popup.last_orders.date}</th>' +
        '<th>{contact_popup.last_orders.time}</th>' +
        '<th>{contact_popup.last_orders.user}</th>' +
        '<th>{contact_popup.last_orders.campaign}</th>' +
        '<th>{contact_popup.last_orders.product}</th>' +
        '<th>{contact_popup.last_orders.order}</th>' +
        '<th>{contact_popup.last_orders.status}</th>' +
        '<th>{contact_popup.last_orders.comment}</th>' +
        '</tr></thead>'));
        var $tbody = $('<tbody>').appendTo($table);

        var loader = that._ordersLoader = new LoadingPopupView(t('activity_indicator.loading'));

        setTimeout(function () { // Do after rendering to screen
            loader.show($el);

            (that._ordersXhr = $.get(app.apiUrl('orders', { 'contact_id': that.options.contactId })))
                .always(function () {
                    loader.hide();
                })
                .then(function(orders) {

                    var statuses = t('order_statuses');

                    if (orders) {
                        orders.forEach(function (row) {
                            var date = new Date(row['created_at']);
                            var $row = $('<tr>');

                            $('<td>').text(i18n.formatDate(date, t('date_formats.normal_date'))).appendTo($row);
                            $('<td>').text(i18n.formatDate(date, t('date_formats.short_time'))).appendTo($row);
                            $('<td>').text(((row['user_first_name'] || '') + ' ' + (row['user_last_name'] || '')).trim()).appendTo($row);
                            $('<td>').text(row['campaign_name']).appendTo($row);
                            $('<td>').text(row['product_name']).appendTo($row);
                            $('<td>').text(row['id']).appendTo($row);
                            $('<td class="bold">').toggleClass('bolds', row['status'] === 'open').text(statuses[row['status']] || '').appendTo($row);
                            $('<td>').text(row['comment']).appendTo($row);

                            $row.appendTo($tbody);
                        });
                    }

                })
                .fail(function(xhr, error) {
                    app.showXhrError(xhr, error);
                });

        }, 0);

        return $el;
    },

    viewOrder: function (orderId) {
        return this.trigger('vieworder', orderId).hide();
    },

    continueOrder: function (orderId) {
        return this.trigger('continueorder', orderId).hide();
    },

    remove: function () {
        var that = this;
        that.$overlay.remove();

        if (that.vueApp) {
            that.vueApp.$destroy();
        }
        if (that._ordersLoader) {
            that._ordersLoader.remove();
        }
        if (that._contactLoader) {
            that._contactLoader.remove();
        }
        if (that._loadContactXhr) {
            that._loadContactXhr.abort();
        }
        if (that._saveContactXhr) {
            that._saveContactXhr.abort();
        }
        if (that._ordersXhr) {
            that._ordersXhr.abort();
        }

        ContactInfoPopup.__super__.remove.apply(this, arguments);
    }

});

export default ContactInfoPopup;
